import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormInput from '../Generals/FormInput/FormInput';
import { Button } from '../Generals/stylesheets/Button.style';
import { ButtonWrapper } from './ScheduleAddLessonSessionForm.style';

const validationSchema = Yup.object().shape({
  subject: Yup.string().trim().required('Subject is required'),
});

class AddLessonSessionStepOne extends Component {
  handleSubmit = (values) => {
    const { handleSubmit } = this.props;
    handleSubmit(values);
  }

  render() {
    const { initialValues, subjects } = this.props;

    return (
      <div>
        {/* form */}
        <Formik
          validationSchema={validationSchema}
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
        >
          <Form noValidate>
            <FormInput
              type="select"
              name="subject"
              label="Session subject"
              options={subjects}
              getOptionValue={option => option.id}
              getOptionLabel={option => option.display_name || option.name}
              isMulti={false}
            />
            <ButtonWrapper>
              <Button submit type="submit">
                Next step
              </Button>
            </ButtonWrapper>
          </Form>
        </Formik>
      </div>
    );
  }
}

AddLessonSessionStepOne.propTypes = {
  subjects: PropTypes.array,
  initialValues: PropTypes.object,
  handleSubmit: PropTypes.func,
};

export default AddLessonSessionStepOne;
